export const FETCH_ATTENDANCE_ADMIN_REQUEST = "FETCH_ATTENDANCE_ADMIN_REQUEST";
export const FETCH_ATTENDANCE_ADMIN_SUCCESS = "FETCH_ATTENDANCE_ADMIN_SUCCESS";
export const FETCH_ATTENDANCE_ADMIN_FAILURE = "FETCH_ATTENDANCE_ADMIN_FAILURE";
